import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06eb1e74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Register" }
const _hoisted_2 = { class: "checkboxWarpper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("接收求购信息")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("接收处理信息")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("添加区域")
const _hoisted_6 = { class: "area" }
const _hoisted_7 = { class: "tagList" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "暂未选择地区，默认推送全国信息", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("添加品种")
const _hoisted_10 = { class: "variety" }
const _hoisted_11 = { class: "tagList" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "添加您关注的品种，快速精确匹配苗木求购信息", -1))
const _hoisted_13 = { class: "submit" }
const _hoisted_14 = {
  class: "variety",
  style: {"padding-bottom":"0","border":"none"}
}
const _hoisted_15 = { class: "tagList" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_17 = { class: "queryResults" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "common" }
const _hoisted_20 = { class: "history" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "常用品种", -1))
const _hoisted_22 = { class: "list" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "history" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "热门搜索", -1))
const _hoisted_26 = { class: "list" }
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanCheckbox = _resolveComponent("VanCheckbox")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanCellGroup = _resolveComponent("VanCellGroup")!
  const _component_VanPicker = _resolveComponent("VanPicker")!
  const _component_VanPopup = _resolveComponent("VanPopup")!
  const _component_VanSearch = _resolveComponent("VanSearch")!
  const _component_VanList = _resolveComponent("VanList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanImage, {
      class: "bg",
      src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/gongzhonghao/gongzhonghao_banner.png"
    }),
    _createVNode(_component_VanCellGroup, null, {
      default: _withCtx(() => [
        _createVNode(_component_VanField, {
          label: "姓名/企业名称",
          "label-width": "100",
          placeholder: "请输入姓名或企业名称",
          required: "",
          "input-align": "right",
          modelValue: _ctx.saveData.nickName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.saveData.nickName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_VanField, {
          label: "手机号",
          "label-width": "100",
          placeholder: "请输入手机号",
          required: "",
          "input-align": "right",
          modelValue: _ctx.saveData.mobile,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.saveData.mobile) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_VanField, {
          label: "接收信息设置",
          "label-width": "90",
          placeholder: "请输入手机号",
          "input-align": "right"
        }, {
          input: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_VanCheckbox, {
                "checked-color": "#19be6b",
                modelValue: _ctx.saveData.receivePurchase,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.saveData.receivePurchase) = $event)),
                shape: "square"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_VanCheckbox, {
                "checked-color": "#19be6b",
                modelValue: _ctx.saveData.receiveProcess,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.saveData.receiveProcess) = $event)),
                shape: "square"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_VanField, {
          label: "采购区域设置",
          "label-width": "100",
          "input-align": "right",
          border: false
        }, {
          input: _withCtx(() => [
            _createVNode(_component_VanButton, {
              size: "small",
              type: "success",
              round: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isAreaShow = true))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saveData.regional, (item, key) => {
              return (_openBlock(), _createBlock(_component_VanTag, {
                plain: "",
                size: "large",
                closeable: key != '0',
                type: "success",
                key: `regional${key}`,
                onClose: ($event: any) => (_ctx.clearRegional(key))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item), 1)
                ]),
                _: 2
              }, 1032, ["closeable", "onClose"]))
            }), 128))
          ]),
          _hoisted_8
        ]),
        _createVNode(_component_VanField, {
          label: "采购品种设置",
          "label-width": "100",
          placeholder: "请输入手机号",
          "input-align": "right",
          border: false
        }, {
          input: _withCtx(() => [
            _createVNode(_component_VanButton, {
              size: "small",
              type: "success",
              round: "",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isAddVarietyShow = true))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saveData.categoryTitle, (item, key) => {
              return (_openBlock(), _createBlock(_component_VanTag, {
                plain: "",
                size: "large",
                closeable: "",
                type: "success",
                key: `categoryTitle${key}`,
                onClose: ($event: any) => (_ctx.clearVariety(key))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item), 1)
                ]),
                _: 2
              }, 1032, ["onClose"]))
            }), 128))
          ]),
          _hoisted_12
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_VanButton, {
        round: "",
        block: "",
        type: "success",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isRegister?'保存':'绑定'), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_VanPopup, {
      show: _ctx.isAreaShow,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isAreaShow) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanPicker, {
          columns: _ctx.areaList,
          onConfirm: _ctx.confirmArea,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isAreaShow = false))
        }, null, 8, ["columns", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      class: "addVarietyPopup",
      show: _ctx.isAddVarietyShow,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isAddVarietyShow) = $event)),
      onClose: _ctx.varietyDialogClose,
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saveData.categoryTitle, (item, key) => {
              return (_openBlock(), _createBlock(_component_VanTag, {
                plain: "",
                size: "large",
                closeable: "",
                type: "success",
                key: `categoryTitle${key}`,
                onClose: ($event: any) => (_ctx.clearVariety(key))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item), 1)
                ]),
                _: 2
              }, 1032, ["onClose"]))
            }), 128))
          ])
        ]),
        _createVNode(_component_VanSearch, {
          modelValue: _ctx.searchData.name,
          "onUpdate:modelValue": [
            _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchData.name) = $event)),
            _ctx.searchVariety
          ],
          placeholder: "请输入品种名称",
          round: "",
          "show-action": "",
          clearable: ""
        }, {
          action: _withCtx(() => [
            _createVNode(_component_VanButton, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isAddVarietyShow = false)),
              size: "small",
              style: {"display":"block"},
              type: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue"]),
        _withDirectives(_createElementVNode("div", _hoisted_17, [
          _createVNode(_component_VanList, {
            class: "queryResultsWarpper",
            loading: _ctx.loading,
            "immediate-check": false,
            finished: _ctx.finished,
            onLoad: _ctx.page
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchVarietyList, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "queryResultsItem",
                  key: `queryResultsItem${idx}`,
                  onClick: ($event: any) => (_ctx.choseVariety(item))
                }, _toDisplayString(item.path), 9, _hoisted_18))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ], 512), [
          [_vShow, _ctx.searchVarietyList.length != 0 && _ctx.searchData.name != ""]
        ]),
        _withDirectives(_createElementVNode("div", { class: "noData" }, "没有找到“" + _toDisplayString(_ctx.searchData.name) + "”品种", 513), [
          [_vShow, _ctx.searchVarietyList.length == 0 && _ctx.searchData.name != "" && !_ctx.loading]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commonVarietyList, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: `commonItem${idx}`,
                  onClick: ($event: any) => (_ctx.choseVariety(item))
                }, _toDisplayString(item.name), 9, _hoisted_23))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotList, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: idx,
                  onClick: ($event: any) => (_ctx.choseVariety(item))
                }, _toDisplayString(item.categoryName), 9, _hoisted_27))
              }), 128))
            ])
          ])
        ], 512), [
          [_vShow, _ctx.searchVarietyList.length == 0 || _ctx.searchData.name == ""]
        ])
      ]),
      _: 1
    }, 8, ["show", "onClose"])
  ]))
}